import React, { useState, useEffect } from 'react';

const sections = [
  { id: 'aksept', label: 'Aksept av vilkår', num: '01' },
  { id: 'tjenester', label: 'Tjenestebeskrivelse', num: '02' },
  { id: 'konto', label: 'Brukerkonto & ansvar', num: '03' },
  { id: 'abonnement', label: 'Abonnementsvilkår', num: '04' },
  { id: 'betaling', label: 'Betalingsbetingelser', num: '05' },
  { id: 'immaterialrett', label: 'Immaterielle rettigheter', num: '06' },
  { id: 'brukerinnhold', label: 'Brukerinnhold & data', num: '07' },
  { id: 'ansvarsbegrensning', label: 'Ansvarsbegrensning', num: '08' },
  { id: 'garanti', label: 'Garantifraskrivelse', num: '09' },
  { id: 'tilgjengelighet', label: 'Tjenestetilgjengelighet', num: '10' },
  { id: 'oppsigelse', label: 'Oppsigelse & suspensjon', num: '11' },
  { id: 'tvistelosning', label: 'Tvisteløsning & lovvalg', num: '12' },
  { id: 'force-majeure', label: 'Force majeure', num: '13' },
  { id: 'kontakt-legal', label: 'Juridisk kontakt', num: '14' },
];

const TermsTableOfContents = () => {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 120;
      for (let i = sections?.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections?.[i]?.id);
        if (el && el?.offsetTop <= scrollPos) {
          setActiveId(sections?.[i]?.id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      window.scrollTo({ top: el?.offsetTop - 100, behavior: 'smooth' });
    }
  };

  return (
    <div
      style={{
        background: '#0A1220',
        border: '2px solid rgba(249,115,22,0.2)',
        padding: '32px',
        position: 'relative',
        transform: 'rotate(0.5deg)'
      }}
    >
      {/* Polaroid tape top */}
      <div
        style={{
          position: 'absolute',
          top: '-12px',
          left: '50%',
          transform: 'translateX(-50%) rotate(-2deg)',
          width: '60px',
          height: '24px',
          background: 'rgba(249,115,22,0.2)',
          border: '1px solid rgba(249,115,22,0.3)'
        }}
      />
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            fontFamily: 'Impact, sans-serif',
            fontSize: '0.75rem',
            color: '#F97316',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            marginBottom: '6px'
          }}
        >
          INNHOLDSFORTEGNELSE
        </div>
        <div
          style={{
            width: '40px',
            height: '3px',
            background: 'linear-gradient(90deg, #F97316, #3B6FD4)'
          }}
        />
      </div>
      {/* Links */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        {sections?.map((section) => (
          <button
            key={section?.id}
            onClick={() => scrollTo(section?.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              background: activeId === section?.id ? 'rgba(249,115,22,0.1)' : 'transparent',
              border: 'none',
              borderLeft: activeId === section?.id ? '2px solid #F97316' : '2px solid transparent',
              padding: '7px 10px',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 150ms ease',
              width: '100%'
            }}
            onMouseEnter={(e) => {
              if (activeId !== section?.id) {
                e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                e.currentTarget.style.borderLeftColor = 'rgba(249,115,22,0.4)';
              }
            }}
            onMouseLeave={(e) => {
              if (activeId !== section?.id) {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderLeftColor = 'transparent';
              }
            }}
          >
            <span
              style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.625rem',
                color: activeId === section?.id ? '#F97316' : 'rgba(138,149,163,0.4)',
                letterSpacing: '0.1em',
                minWidth: '24px'
              }}
            >
              {section?.num}
            </span>
            <span
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.75rem',
                color: activeId === section?.id ? '#EEF0F2' : 'rgba(138,149,163,0.7)',
                lineHeight: 1.4
              }}
            >
              {section?.label}
            </span>
          </button>
        ))}
      </div>
      {/* Bottom accent */}
      <div
        style={{
          marginTop: '20px',
          paddingTop: '16px',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.625rem',
          color: 'rgba(138,149,163,0.3)',
          letterSpacing: '0.08em'
        }}
      >
        NordPass AS · Vilkår v1.0 · Feb 2026
      </div>
    </div>
  );
};

export default TermsTableOfContents;
